import React, { useEffect, useMemo, useState } from 'react'
import st from './NewAndWonDeals.module.scss'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import { Link, useLocation, useParams } from 'react-router-dom'
import { superAxiosRequest } from 'axiosApi'
import useLocalization from 'hooks/useLocalization'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import Pagination from 'components/UI/Pagination/Pagination'
import { observer } from 'mobx-react'
import listingStore from 'Stores/listingStore'
import Loader from '../../UI/Loader/Loader'

const NewDeals = (props) => {
  const [deals, setDeals] = useState(null)
  const [meta, setMeta] = useState({})
  const [loading, setLoading] = useState(false)

  const [filter, updateFilter] = useLocalStorageFilter({})
  const { page, perPage, setPage, setPerPage } = listingStore

  const location = useLocation()

  const { id } = useParams()

  const queryParams = new URLSearchParams(location.search)
  const dealsIds = queryParams.get('deals_ids')
  const statusNameFromUrl = queryParams.get('status_name')

  const dealsPayload = dealsIds
    ? {
        deals_ids: dealsIds.split(',').map(Number),
      }
    : null

  const statusId = useMemo(() => props.match.params.status_id, [])

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      filter: 'Filter',
      search: 'Search',
      start_date: 'Start Date',
      end_date: 'End Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      new_deals: 'New deals',
      search_placeholder: 'Search',
      deals_name: 'Deals name',
      telephone: 'Telephone',
      responsible: 'Responsible',
      creation_date: 'Creation date',
      deal_stage: 'Deal stage',
      changed_by: 'Changed by',
      date_modified: 'Date modified',
      deals_name_field: 'Deals name',
      start_finish_date: 'Start & Finish Date',
      deal_status: 'Deal status',
      deals_source: 'Deals source',
      responsible_field: 'Responsible',
      created_by: 'Created by',
      changed_by_field: 'Changed by',
      won_deals: 'Won deals',
      of: 'of',
      whatsapp: 'WhatsApp',
    },
  })

  const fetchDealsByIds = async () => {
    if (
      !dealsPayload ||
      !dealsPayload.deals_ids ||
      dealsPayload.deals_ids.length === 0
    ) {
      console.warn('Нет данных для POST-запроса')
      setDeals([])
      setMeta({})
      setLoading(false)
      return
    }

    try {
      setLoading(true)

      const response = await superAxiosRequest(
        {
          method: 'post',
          link: 'integration/deals_list',
          crm: true,
          params: {
            limit: perPage,
            offset: (page - 1) * perPage,
          },
        },
        dealsPayload,
        null,
        null,
      )

      setDeals(response?.data?.result || response?.data || [])
      setMeta(response?.data?._meta || {})

      listingStore.meta = {
        ...listingStore.meta,
        count_items: response?.data?._meta?.count_items || 0,
      }
    } catch (error) {
      console.error('Ошибка при POST-запросе:', error)
      setDeals([])
      setMeta({})
    } finally {
      setLoading(false)
    }
  }

  const getContactInfo = (deal) => {
    if (deal?.client) {
      return {
        phone: deal.client.phone || '',
        whatsapp: deal.client.whatsapp || '',
      }
    }

    if (deal?.lead?.client) {
      return {
        phone: deal.lead.client.phone || '',
        whatsapp: deal.lead.client.whatsapp || '',
      }
    }

    return { phone: '', whatsapp: '' }
  }

  useEffect(() => {
    fetchDealsByIds()
  }, [filter, page, perPage, statusId, id])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  const funnelName = useMemo(() => {
    // Если есть название статуса из URL, используем его
    if (statusNameFromUrl) {
      return statusNameFromUrl
    }

    // Иначе пытаемся получить из данных
    if (deals && deals.length > 0 && deals[0]?.funnels?.length > 0) {
      return deals[0].funnels[0].name
    }

    return 'Deals'
  }, [deals, statusNameFromUrl])

  return (
    <div>
      <div className={st.header}>
        <div>
          <PageHeader title={funnelName} />
        </div>
      </div>

      <div className={st.containerClient}>
        {loading ? (
          <Loader fullWidth />
        ) : (
          <table className={st.dealsTable}>
            <thead>
              <tr>
                <th>{translate.deal_name}</th>
                <th>{translate.telephone}</th>
                <th>{translate.whatsapp}</th>
                <th>{translate.responsible}</th>
                <th>{translate.creation_date}</th>
                <th>{translate.deal_stage}</th>
              </tr>
            </thead>
            <tbody>
              {deals?.length > 0 ? (
                deals
                  ?.slice()
                  .sort(
                    (a, b) => new Date(a?.created_at) - new Date(b?.created_at),
                  )
                  ?.map((deal, index) => {
                    const contactInfo = getContactInfo(deal)
                    return (
                      <tr
                        key={`${deal.id}-${index}`}
                        className={index % 2 === 0 ? st.evenRow : st.oddRow}
                      >
                        <td>
                          <Link
                            className={st.clickableDealName}
                            to={`/crm/customer-card/${deal?.id}/?funnel_id=${deal?.funnels[0]?.id}`}
                          >
                            {deal?.deal_name}
                          </Link>
                        </td>
                        <td>{contactInfo.phone}</td>
                        <td>
                          {contactInfo.whatsapp ? contactInfo.whatsapp : '-'}
                        </td>
                        <td>{deal?.manager ? deal?.manager?.name : ''}</td>
                        <td>
                          {new Date(deal?.created_at).toLocaleDateString()}
                        </td>
                        <td>
                          <div className={st.square}>
                            <div
                              className={st.tips}
                              style={{
                                backgroundColor:
                                  deal?.funnels[0]?.status_deal?.color
                                    ?.body_color || '#97F4FF',
                              }}
                              data-tooltip={deal?.funnels[0]?.status_deal?.name}
                            />
                            {deal?.status_deal?.name ||
                              deal?.funnels[0]?.status_deal?.name}
                          </div>
                        </td>
                      </tr>
                    )
                  })
              ) : (
                <tr>
                  <td colSpan='7' className={st.noData}>
                    Нет данных
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {!loading && meta.count_items > 0 && (
        <div className={st.pagination}>
          <Pagination
            translate={translate}
            limit={+perPage}
            count={meta.count_items || 0}
            page={page}
            onChange={setPage}
            onChangePerPage={setPerPage}
          />
        </div>
      )}
    </div>
  )
}

export default observer(NewDeals)
